import React from "react";
import matavfall from "../images/matavfall.png";

export type FrontpageNewsItem = {
  title: string;
  leftImage?: string;
  leftImageAlt?: string;
  body: React.JSX.Element;
};

export const allNews: FrontpageNewsItem[] = [
  {
    title: "Ny rutin för betalning av samfällighetsavgiften",
    body: (
      <>
        <p>
          Fr o m kvartal 3 2024 som betalas senast den sista juni automatiseras
          hanteringen av samfällighetsavgiften. Det innebär att:
        </p>

        <ul>
          <li>
            Faktura på samfällighetsavgift och internet skickas ut via mail
            inför varje betalningstillfälle.
          </li>
          <li>
            Betalning sker sedan via fakturan senast det datum som anges som
            sista betalningsdatum.
          </li>
          <li>
            Vid betalningen anges OCR-numret på fakturan. OCR-numret visar
            vilken fastighet betalningen avser.
          </li>
          <li>
            Om inte betalning kommit in till sista betalningsdatum kommer en
            påminnelse att mailas ut efter ett par dagar.
          </li>
          <li>
            Upprepade sena betalningar kan leda till extra förseningsavgift på
            500 kr
          </li>
          <li>
            Om det är någon som saknar mailkonto kommer vi att lämna faktura och
            eventuell påminnelse i brevlådan.
          </li>
        </ul>

        <p>
          OBS! Om du lagt in automatisk överföring av avgiften via din bank
          måste du stoppa dessa.
        </p>
        <p>
          På det här sättet hoppas styrelsen att vi får en smidigare hantering
          av avgiftsbetalningarna.
        </p>
      </>
    ),
  },
  {
    leftImage: matavfall,
    leftImageAlt: "Matavfall",
    title: "Information om Matavfallssorteringen",
    body: (
      <>
        <p>
          Sedan den 8 april har vi matavfallssortering i området. Genom att
          slänga matavfallet separat minskar vi kostnaden för övrig sophämtning.
        </p>

        <p>
          Samtliga hushåll har fått ett startkit med behållare, påsar och
          informationsfolder. Det är viktigt att vi följer anvisningarna i
          informationen när vi sorterar matavfallet och inte slänger något annat
          i behållarna.
        </p>

        <p>
          Matavfallskärlen står vid varje parkeringslänga. Inledningsvis kommer
          de att tömmas en gång per vecka. Om det skulle visa sig att det blir
          fullt snabbare kan vi beställa hämtning oftare eller beställa fler
          kärl. Nya påsar kommer att finnas att hämta i förrådet vid övre
          parkeringen.
        </p>
      </>
    ),
  },
  {
    title: "Höjd Samfällighetsavgift",
    body: (
      <>
        <p>
          Vid årsmötet den 21 februari 2024 fattades beslut om höjning av
          samfällighetsavgiften. Avgiften höjs med 100 kr/månad (300 kr/kvartal)
        </p>

        <p>
          Detta innebär att den nya avgiften är 4 440 kr per kvartal + 630 kr
          per kvartal för kollektivt bredbandsavtal. Totalt alltså{" "}
          <strong>5 070 kr per kvartal</strong>. Detta gäller de 42 hushåll som
          tecknat gruppabonnemang för internet. (För ett hushåll som inte
          tecknat gruppabonnemang är avgiften 4 440 per kvartal)
        </p>

        <p>
          Den nya avgiften skall betalas fr o m nästa inbetalningstillfälle, dvs
          senast den 31 mars.
        </p>
      </>
    ),
  },
];
